<template>
   <b-container class="form-container bg-white shadow">
    <h3 class="col-12 text-dark py-4 mb-0">Edit My Profile</h3>
    <AccountForm :initialAccount="user" @submitted="submitSuccess" :allowCancel="true" :edit="true" />
    <b-modal
      ref="accountUpdatedModal"
      id="accountUpdatedModal"
      centered
      title="Profile Updated"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      @ok="$router.push({ name: 'dashboard' })"
    >
      Your account was successfully updated.
      <template v-slot:modal-footer="{ ok }">
        <b-button pill variant="primary" class="full-width text-center" @click="ok()" aria-label="Confirm profile update">
          Ok
        </b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';
import AccountForm from '@/components/account/AccountForm.vue';

export default {
  name: 'MyProfile',
  components: {
    AccountForm,
  },
  computed: {
    ...mapState('User', {
      user: state => state.user,
    }),
  },
  methods: {
    submitSuccess() {
      this.$refs.accountUpdatedModal.show();
    },
  },
};
</script>
